module.exports = __webpack_public_path__ + "static/media/form.9a66cf19.svg";